var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.conditions.screen == _vm.screens.list.value ? _c('div', {
    staticClass: "mt-24px w-100"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "dialer-edit-title"
  }, [_vm._v("Groups")]), _c('b-button', {
    staticClass: "newButton",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.conditions.screen = _vm.screens.add.value;
      }
    }
  }, [_c('vb-icon', {
    attrs: {
      "icon": "squared-add-icon",
      "height": "38px",
      "width": "38px"
    }
  }), _c('span', {
    staticClass: "newButton-textPart"
  }, [_vm._v("Add group")])], 1)], 1), _c('vb-table', {
    staticClass: "latestTableDesign-withBlackBorders-again hasSoundFiles",
    attrs: {
      "isListEmpty": _vm.response.groups.length == 0,
      "listLength": _vm.response.groups.length,
      "loading": _vm.api.get_groups.send
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (_ref) {
        var start = _ref.start,
          end = _ref.end;
        return _vm._l(_vm.response.groups, function (group, index) {
          return _c('tr', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: index >= start && index <= end,
              expression: "index >= start && index <= end"
            }],
            key: group.id
          }, [_c('td', {
            staticClass: "dialer-row-title"
          }, [_vm._v(_vm._s(group.name))]), _c('td', {
            staticClass: "dialer-has-sort text-center dialer-col-center"
          }, [_c('div', {
            staticClass: "createSpace-selectColor-container justify-content-center"
          }, [_c('div', {
            staticClass: "createSpace-selectColor-item selected",
            class: {
              'TransparentSelected': group.color == 'rgba(0,0,0,0)'
            },
            style: `background-color:${group.color};`
          })])]), _c('td', {
            staticClass: "dialer-has-sort dialer-col-right"
          }, [_c('div', {
            staticClass: "d-flex justify-content-end align-items-center filterDD dropdownVersion whiteBGinputWithGreyRoundedBorder buttonHeightAuto buttonWidthAuto"
          }, [_c('b-dropdown', {
            staticClass: "w-auto",
            attrs: {
              "toggle-class": "p-0",
              "no-caret": "",
              "disabled": !!_vm.api.remove_group.send,
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "button-content",
              fn: function () {
                return [_c('vb-icon', {
                  staticClass: "mx-auto todo-three-dots-vertical-icon",
                  attrs: {
                    "icon": "todo-three-dots-vertical-icon",
                    "variant": "dark",
                    "width": "6px",
                    "height": "18px"
                  }
                })];
              },
              proxy: true
            }], null, true)
          }, [_c('b-dropdown-item', {
            on: {
              "click": function ($event) {
                return _vm.setUpdate(group);
              }
            }
          }, [_vm._v("Edit")]), _c('b-dropdown-item', {
            on: {
              "click": function ($event) {
                return _vm.$modal.show('TodoTaskMove', {
                  moved: true,
                  select: 'group',
                  space_id: _vm.space_id,
                  payload: {
                    group_id: group.id,
                    flag: 'group'
                  }
                });
              }
            }
          }, [_vm._v("Move task")]), group.created_by ? _c('b-dropdown-item', {
            on: {
              "click": function ($event) {
                return _vm.remove(group);
              }
            }
          }, [_vm._v("Delete")]) : _vm._e()], 1)], 1)])]);
        });
      }
    }, {
      key: "loading",
      fn: function () {
        return _vm._l(5, function (n) {
          return _c('tr', {
            key: n
          }, [_c('td', [_c('div', {
            staticClass: "d-flex align-items-center w-fit-content"
          }, [_c('div', {
            staticClass: "latestShimmerDesign",
            staticStyle: {
              "height": "21px",
              "width": "80px"
            }
          })])]), _c('td', [_c('div', {
            staticClass: "d-flex align-items-center w-fit-content mx-auto"
          }, [_c('div', {
            staticClass: "md-mar-left latestShimmerDesign",
            staticStyle: {
              "height": "21px",
              "width": "21px"
            }
          })])]), _c('td', [_c('div', {
            staticClass: "d-flex align-items-center justify-sontent-end w-fit-content ml-auto"
          }, [_c('div', {
            staticClass: "latestShimmerDesign",
            staticStyle: {
              "height": "16px",
              "width": "70px"
            }
          })])])]);
        });
      },
      proxy: true
    }], null, false, 3669329100)
  }, [_c('tr', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('th', {
    staticClass: "dialer-has-sort py-3 border-0"
  }, [_c('span', [_vm._v("Title")])]), _c('th', {
    staticClass: "dialer-has-sort py-3 text-center dialer-col-center"
  }, [_c('span', [_vm._v("Color")])]), _c('th', {
    staticClass: "dialer-has-sort py-3 dialer-col-right"
  })])])], 1) : _vm._e(), _vm.conditions.screen == _vm.screens.add.value ? _c('form', {
    staticClass: "createSpace-greyBox mt-24px",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.create();
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "show": !!_vm.api.create_group.error_message,
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.api.create_group.error_message))]), _c('div', {
    staticClass: "whiteBGinputWithGreyRoundedBorder"
  }, [_c('label', [_vm._v("Group name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.forms.create_group.name,
      expression: "forms.create_group.name"
    }],
    staticClass: "w-100 bg-white",
    attrs: {
      "type": "text",
      "placeholder": "Group name",
      "disabled": _vm.api.create_group.send,
      "maxlength": _vm.$v.forms.create_group.name.$params.maxLength.max
    },
    domProps: {
      "value": _vm.forms.create_group.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.forms.create_group, "name", $event.target.value);
      }
    }
  }), _vm.forms.create_group.submitted && _vm.$v.forms.create_group.name.$invalid || _vm.api.create_group.validation_errors.name ? _c('p', {
    staticClass: "mb-1 text-small text text-danger animated bounceIntop"
  }, [!_vm.$v.forms.create_group.name.required ? _c('span', [_vm._v("* Group name is required")]) : !_vm.$v.forms.create_group.name.minLength ? _c('span', [_vm._v("* Group name should be minimum " + _vm._s(_vm.$v.forms.create_group.name.$params.minLength.min) + " character")]) : !_vm.$v.forms.create_group.name.maxLength ? _c('span', [_vm._v("* Group name can be maximum " + _vm._s(_vm.$v.forms.create_group.name.$params.maxLength.max) + " character")]) : _vm._e(), _vm._l(_vm.api.create_group.validation_errors.name, function (em, index) {
    return _c('span', {
      key: index
    }, [_vm._v("* " + _vm._s(em))]);
  })], 2) : _vm._e()]), _c('div', {
    staticClass: "whiteBGinputWithGreyRoundedBorder mt-20px"
  }, [_c('label', [_vm._v("Choose color")]), _c('div', {
    staticClass: "createSpace-selectColor-container"
  }, _vm._l(_vm.colors, function (color, i) {
    return _c('div', {
      key: i,
      staticClass: "createSpace-selectColor-item-container",
      on: {
        "click": function ($event) {
          _vm.api.create_group.send ? '' : _vm.forms.create_group.color = color;
        }
      }
    }, [_c('div', {
      staticClass: "createSpace-selectColor-item",
      class: {
        'selected': _vm.forms.create_group.color == color,
        'TransparentSelected': color == 'rgba(0,0,0,0)'
      },
      style: `background-color:${color};`
    }, [color == 'rgba(0,0,0,0)' ? _c('vb-icon', {
      attrs: {
        "icon": "todo-transparentColored-icon",
        "height": "28px",
        "width": "30px"
      }
    }) : _vm._e()], 1)]);
  }), 0), _vm.forms.create_group.submitted && _vm.$v.forms.create_group.color.$invalid || _vm.api.create_group.validation_errors.color ? _c('p', {
    staticClass: "mb-1 text-small text text-danger animated bounceIntop"
  }, [!_vm.$v.forms.create_group.color.required ? _c('span', [_vm._v("* Color is required")]) : !_vm.$v.forms.create_group.color.validColor ? _c('span', [_vm._v("* Color is invalid")]) : _vm._e(), _vm._l(_vm.api.create_group.validation_errors.color, function (em) {
    return _c('span', {
      key: em
    }, [_vm._v("* " + _vm._s(em))]);
  })], 2) : _vm._e()]), _vm._m(0)], 1) : _vm._e(), _vm.conditions.screen == _vm.screens.update.value ? _c('form', {
    staticClass: "createSpace-greyBox mt-24px",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.update();
      }
    }
  }, [_c('b-alert', {
    attrs: {
      "show": !!_vm.api.update_group.error_message,
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.api.update_group.error_message))]), _c('div', {
    staticClass: "whiteBGinputWithGreyRoundedBorder"
  }, [_c('label', [_vm._v("Group name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.forms.update_group.name,
      expression: "forms.update_group.name"
    }],
    staticClass: "w-100 bg-white",
    attrs: {
      "type": "text",
      "placeholder": "Group name",
      "disabled": _vm.api.update_group.send,
      "maxlength": _vm.$v.forms.update_group.name.$params.maxLength.max
    },
    domProps: {
      "value": _vm.forms.update_group.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.forms.update_group, "name", $event.target.value);
      }
    }
  }), _vm.forms.update_group.submitted && _vm.$v.forms.update_group.name.$invalid || _vm.api.update_group.validation_errors.name ? _c('p', {
    staticClass: "mb-1 text-small text text-danger animated bounceIntop"
  }, [!_vm.$v.forms.update_group.name.required ? _c('span', [_vm._v("* Group name is required")]) : !_vm.$v.forms.update_group.name.minLength ? _c('span', [_vm._v("* Group name should be minimum " + _vm._s(_vm.$v.forms.update_group.name.$params.minLength.min) + " character")]) : !_vm.$v.forms.update_group.name.maxLength ? _c('span', [_vm._v("* Group name can be maximum " + _vm._s(_vm.$v.forms.update_group.name.$params.maxLength.max) + " character")]) : _vm._e(), _vm._l(_vm.api.update_group.validation_errors.name, function (em, index) {
    return _c('span', {
      key: index
    }, [_vm._v("* " + _vm._s(em))]);
  })], 2) : _vm._e()]), _c('div', {
    staticClass: "whiteBGinputWithGreyRoundedBorder mt-20px"
  }, [_c('label', [_vm._v("Choose color")]), _c('div', {
    staticClass: "createSpace-selectColor-container"
  }, _vm._l(_vm.colors, function (color, i) {
    return _c('div', {
      key: i,
      staticClass: "createSpace-selectColor-item-container",
      on: {
        "click": function ($event) {
          _vm.api.update_group.send ? '' : _vm.forms.update_group.color = color;
        }
      }
    }, [_c('div', {
      staticClass: "createSpace-selectColor-item",
      class: {
        'selected': _vm.forms.update_group.color == color,
        'TransparentSelected': color == 'rgba(0,0,0,0)'
      },
      style: `background-color:${color};`
    }, [color == 'rgba(0,0,0,0)' ? _c('vb-icon', {
      attrs: {
        "icon": "todo-transparentColored-icon",
        "height": "28px",
        "width": "30px"
      }
    }) : _vm._e()], 1)]);
  }), 0), _vm.forms.update_group.submitted && _vm.$v.forms.update_group.color.$invalid || _vm.api.update_group.validation_errors.color ? _c('p', {
    staticClass: "mb-1 text-small text text-danger animated bounceIntop"
  }, [!_vm.$v.forms.update_group.color.required ? _c('span', [_vm._v("* Color is required")]) : !_vm.$v.forms.update_group.color.validColor ? _c('span', [_vm._v("* Color is invalid")]) : _vm._e(), _vm._l(_vm.api.update_group.validation_errors.color, function (em) {
    return _c('span', {
      key: em
    }, [_vm._v("* " + _vm._s(em))]);
  })], 2) : _vm._e()]), _vm._m(1)], 1) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 d-flex justify-content-end mt-20px"
  }, [_c('button', {
    staticClass: "fullWidthDoneButton",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Add ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 d-flex justify-content-end mt-20px"
  }, [_c('button', {
    staticClass: "fullWidthDoneButton",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Update ")])]);

}]

export { render, staticRenderFns }